import React from "react"
import { useSelector } from "react-redux"
import { App } from "components/views/app/App"
import Loading from "components/views/Loading"
import { getUserInfoLoaded } from "reducers/userInfo"
import { getIsBenefitConfigurationLoaded } from "reducers/benefitConfiguration"
import { BenefitEnrollmentProvider } from "components/context/enrollment/BenefitEnrollmentContext"
import { DeductibleProvider } from "components/context/user/DeductibleContext"
import { FeatureToggleContextProvider } from "components/context/feature-toggle/FeatureToggleContext"
import { RoutingInfoContextProvider, useRoutingInfo } from "components/carrot-plans/context/RoutingInfoContext"
import { MemberPoseWarningMessage } from "../../member-pose/MemberPoseWarningMessage"
import { ConnectInsuranceContextProvider } from "../../context/enrollment/ConnectInsuranceContext"
import { UserContextProvider } from "components/context/user/UserContext"
import { useBenefitEnrollmentStatus } from "../../context/enrollment/hooks/useBenefitEnrollmentStatus"
import { MedicalInfoContextProvider, useMedicalInfo } from "../../carrot-plans/context/MedicalInfoContext"
import { CarrotPlanModal } from "components/carrot-plans/CarrotPlansModal"

export function AppLoadingContainer(props) {
  const { initialLoading: routingInfoInitialLoading } = useRoutingInfo()
  const { initialLoading: medicalInfoInitialLoading } = useMedicalInfo()
  const { initialLoading: benefitEnrollmentStatusLoading } = useBenefitEnrollmentStatus()
  const isUserInfoLoaded = useSelector(getUserInfoLoaded)
  const isBenefitConfigurationLoaded = useSelector(getIsBenefitConfigurationLoaded)

  const isDataLoaded = [
    !benefitEnrollmentStatusLoading,
    isUserInfoLoaded,
    isBenefitConfigurationLoaded,
    !routingInfoInitialLoading
  ].every((i) => i)

  return isDataLoaded ? props.children : <Loading />
}

export function BlockingAppContext(props) {
  return (
    <UserContextProvider>
      <RoutingInfoContextProvider>
        <MedicalInfoContextProvider>{props.children}</MedicalInfoContextProvider>
      </RoutingInfoContextProvider>
    </UserContextProvider>
  )
}

export function AppContext(props) {
  return (
    <FeatureToggleContextProvider>
      <DeductibleProvider>
        <BenefitEnrollmentProvider>
          <ConnectInsuranceContextProvider>{props.children}</ConnectInsuranceContextProvider>
        </BenefitEnrollmentProvider>
      </DeductibleProvider>
    </FeatureToggleContextProvider>
  )
}

function AppContainer() {
  return (
    <BlockingAppContext>
      <AppLoadingContainer>
        <AppContext>
          <MemberPoseWarningMessage />
          <CarrotPlanModal />
          <App />
        </AppContext>
      </AppLoadingContainer>
    </BlockingAppContext>
  )
}

export { AppContainer }
